import { IAddress } from './IAddress';
import { IInsuranceCarriers } from './IInsuranceCarriers';
import { ILocationDetails } from './ILocationDetails';

export class IUserDetails {
    userId: string;
    userPassword: string;
    newPassword: string;
    salt: any;
    ssn: string;
    designation: string;
    lastName: string;
    middleName: string;
    firstName: string;
    userGender: string;
    userDob: Date;
    maritalStatus: string;
    photo: any;
    salutation: string;
    ownQuestion: string;
    securityQuestion: string;
    securityAnswer: string;
    startDate: Date;
    endDate: Date;
    isDragonEnabled: boolean;
    isLocked: boolean;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    addressId: number;
    roleId: string;
    permissionCode: string;
    permissionId: string;
    roleName: string;
    // userRole: RoleDTO[];
    // userPermissionMaster: PermissionMaster[];
    usercarriers: IInsuranceCarriers[];
    // userPayers:any[];
    fullName: string;
    ASC: boolean;
    billing: boolean;
    clinic: boolean;
    dbOperation: string;
    isExternal: boolean;
    passwordReset: boolean;
    name: string;
    userAddressDetails: IAddress;
    wrongAttempts: number;
    clinicWrongAttempts: number;
    txtColVisiblity: boolean;
    passwordCaseSensitivity: boolean;
    passwordExpiryPeriod: number;
    currentDate: Date;
    serverDate: Date;
    signatureSizeImage: any;
    userNameSpaceId: string;
    userUid: string;
    userUidType: string;
    userNameTypeCode: string;
    userIdentifierTypeCode: string;
    userIdentity: number;
    npiNumber: string;
    deaNumber: string;
    tinNumber: string;
    address1: string;
    address2: string;
    address3: string;
    state: string;
    city: string;
    postalCode: string;
    phone: string;
    fax: string;
    providerId: string;
    serviceLevel: string;
    userVerificationCode: string;
    userVerificationInfo: string;
    taxId: string;
    facilityId: number;
    primarySpeciality: string;
    specialityCode: string;
    suffix: string;
    email: string;
    ssProvider: boolean;
    spi: string;
    locationId: string;
    defaultLocationId?: any;
    providerType: string;
    billingLocationId: number;
    paytoLocationId: number;
    payToProviderId: number;
    renderingLocationId: number;
    physician: boolean;
    supervisingProvider: string;
    isSupervising: boolean;
    clientId: number;
    appointmentBookingLimit: number;
    manageBillerId: string;
    claimType: string;
    taxonomy: string;
    bpPayerNames: string;
    billProvFullAdrs: string;
    payerIdsMb: string;
    payerNamesMb: string;
    isActiveForManageBiller: boolean;
    defaultProvider: boolean;
    postalCodeExt: string;
    stateCode: string;
    client: string;
    securityCode: string;
    status: string;
    staffType: string;
    // providerStates: StateListDTO[];
    activeStatus: string;
    claimTypeName: string;
    isPrescriber: boolean;

    userIdentify: string[];
    userName: string;
    epcs: boolean;
    salutationName: string;
    locationIds: any;
    lstuserlocations: ILocationDetails[];
    userLocations: string;
    checkuserSignature: boolean;
    selected: boolean;
    UserSessionId?: string;
    isdirect: boolean;
    directaddress: string;
    displayRoleName?: string;
    UserAliasName?: string;
    isParentFacility?: boolean;
}

export class ILoginSessionByLoginUser {
    userId: string;
    loginSessionId: string;
    facilityId: string;
    selectMode: string;

}

export class ITaxonomy {
    taxonomyCode: string;
    taxonomyName: string;
    grouping: string;
    classification: string;
    notes: string;
    section: string;
}
